export interface IupdateUserDetailsReq {
  organizationName: string,
  email: string,
  lastLoginDate: string
}
